"use client";

import { usePath, useRouter, useSearch } from "@packages/framework";
import { useCallback } from "react";

import type { HallowQueries } from "../lib/types/hallowQueries.types";

export const useRedirects = () => {
  const router = useRouter();
  const pathname = usePath();
  const searchParams = useSearch();

  const redirectToSubscribe = useCallback(
    async ({
      newWindow = false,
      redirectBackOnSubscription = true,
    }: { newWindow?: boolean; redirectBackOnSubscription?: boolean } = {}) => {
      if (redirectBackOnSubscription) {
        const currentSearch = searchParams.toString();
        const fullPath = currentSearch
          ? `${pathname}?${currentSearch}`
          : pathname;
        const subscribeUrl = `/upgrade/subscribe?redirect=${encodeURIComponent(fullPath)}`;
        if (newWindow) window.open(subscribeUrl);
        else return router.push(subscribeUrl);
      } else {
        if (newWindow) window.open("/upgrade/subscribe");
        else return router.push("/upgrade/subscribe");
      }
    },
    [pathname, router, searchParams.toString()],
  );

  const redirectToAuth = useCallback(
    async ({
      newWindow = false,
      queries = {},
    }: {
      newWindow?: boolean;
      queries?: HallowQueries;
    } = {}) => {
      const loginURLSearchParams = new URLSearchParams();
      if (queries) {
        for (const [key, val] of Object.entries(queries)) {
          loginURLSearchParams.set(key, val);
        }
      }
      const currentSearch = searchParams?.toString();
      const fullPath = currentSearch
        ? `${pathname}?${currentSearch}`
        : pathname;
      const url = `/login?redirect=${encodeURIComponent(fullPath)}&${loginURLSearchParams.toString()}`;
      if (newWindow) {
        window.open(url);
      } else {
        return router.push(url);
      }
    },
    [pathname, router, searchParams?.toString()],
  );

  return { redirectToSubscribe, redirectToAuth };
};
